export const GOAL_STRUCTURE = 
[
  {
    text: "Lose weight",
    value: "Lose weight",
    categories: [
      { text: "Be at X kgs", value: "Be at X kgs", measurements: ["kg"] },
      {
        text: "Comfortably wear X clothing size",
        value: "Comfortably wear X clothing size",
        measurements: ["size"],
      },
      {
        text: "Lose X cm in total",
        value: "Lose X cm in total",
        measurements: [{text: "cm", targetPlaceholder: "Target total cm"}],
      },
    ],
  },
  {
    text: "Run better",
    value: "Run better",
    categories: [ { text: "Run X km in Y minutes", value: "Run X km in Y minutes", measurements: ["km", "minutes"] }],
  },
  {
    text: "Get stronger",
    value: "Get stronger",
    categories: [
      { text: "Comfortably wear X clothing size", value: "Comfortably wear X clothing size", measurements: ["size"]},
      { text: "Complete X activity", value: "Complete X activity", measurements: [{ text: "", textUnit: true}]},
      { text: "Gain X kg", value: "Gain X kg", measurements: ["kg"]},
      { text: "Lose X cm in total", value: "Lose X cm in total", measurements: [{text: "cm", targetPlaceholder: "Target total cm"}]},
      { text: "Gain X cm in total", value: "Gain X cm in total", measurements: [{text: "cm", targetPlaceholder: "Target total cm"}]},
    ],
  },
  {
    text: "Stay fit",
    value: "Stay fit",
    categories: [
      { text: "Complete X activity", value: "Complete X activity", measurements: [{ text: "", textUnit: true}]},
      { text: "Be at X kgs", value: "Be at X kgs", measurements: ["kg"]},
      { text: "Lose X cm in total", value: "Lose X cm in total", measurements: [{text: "cm", targetPlaceholder: "Target total cm"}]},
    ],
  },
  {
    text: "Build a healthy mindset",
    value: "Healthy mindset",
    categories: [
      { timeframe: "CHECKIN", text: "Complete X activities", value: "Complete X activities", measurements: [{ text: "activities", activities: true }] },
      { timeframe: "CHECKIN", text: "Complete X nutrition logs", value: "Complete X nutrition logs", measurements: ["logs"]},
      { timeframe: "BHAG", text: "Implemented all five mindset principles in daily life", value: "Implemented mindset principles" },
      { timeframe: "BHAG", text: "Implemented all five nutrition principles in daily life", value: "Implemented nutrition principles"}
    ],
  },
  {
    text: "Have a healthy pregnancy",
    value: "Healthy pregnancy",
    categories: [
      { timeframe: "CHECKIN", text: "Log X activities", value: "Log X activities", measurements: [{ text: "activities", activities: true }] },
      { timeframe: "BHAG", text: "Gaining a healthy weight and feeling strong", value: "Gaining a healthy weight and feeling strong" }
    ]
  }
];